module.exports = __webpack_public_path__ + "media/pro/pay_with_apple-2dc24022.svg";